/* eslint-disable react/no-danger */
import React from "react"
import styles from "./HtmlContent.scss"

const HtmlContent = ({content, className}) => (
	<div
		className={`${styles.content} ${className}`}
		dangerouslySetInnerHTML={{__html: content}}
	/>
)
HtmlContent.propTypes = {
	content: React.PropTypes.string,
}

export default HtmlContent



// WEBPACK FOOTER //
// ./elements/HtmlContent.jsx